<div *ngIf="this.isLoading" class="progress-spinner">
	<p-progressSpinner></p-progressSpinner>
</div>
<div class="grid" data-cy="dashboard">
	<!-- Main Content Area -->
	<div class="col-12 lg:col-6">
		<!--Daily Task Summary-->
		<div class="card mb-3">
			<div class="flex align-items-center justify-content-between">
				<h4 class="m-0">
					Daily Task Summary <span *ngIf="summaryDate"> - {{ summaryDate }}</span>
				</h4>

				<button (click)="toggleWidgetPanel()" class="toggle-button" data-cy="toggle-widget-panel-button" title="Toggle widget panel">
					<i class="pi pi-chart-line"></i>
				</button>
			</div>
			<div class="mb-3">
				<app-widget-panel #widgetPanel></app-widget-panel>
			</div>
			<app-daily-task-summary></app-daily-task-summary>
			<app-ai-tasks></app-ai-tasks>
		</div>
		<!--Daily Task Summary Ends-->
		<app-my-claimed-tasks></app-my-claimed-tasks>
	</div>

	<!-- Sidebar Area -->
	<div class="col-12 lg:col-6">

		<div class="card mb-3">
			<app-top-widget-panel
				(widgetClick)="handleWidgetClick($event)"
				[activeWidget]="activeTab"
				[followUpCount]="followUpCount"
				[mentionCount]="mentionCount"
				[outstandingCount]="outstandingTasksCount"
				[unclaimedCount]="unclaimedTasks.length"
			></app-top-widget-panel>
		</div>
		<div class="card mb-3">
			<div *ngIf="activeTab === 'unclaimed'">
				<h4 class="pt-1">Unclaimed Tasks - {{ unclaimedTasks.length }}</h4>
			</div>
			<div *ngIf="activeTab === 'followups'">
				<h4 class="pt-1">Follow Ups - {{ followUpCount }}</h4>
			</div>
			<div *ngIf="activeTab === 'mentions'">
				<h4 class="pt-1">Mentions - {{ mentionCount }}</h4>
			</div>

			<div *ngIf="activeTab === 'unclaimed'">
				<app-unclaimed-tasks
					(claimTasksEvent)="claimTasks($event)"
					[isClaiming]="isClaimingUnclaimedTasks"
					[isLoading]="isLoadingUnclaimedTasks"
					[unclaimedTasks]="filteredTasks"
				></app-unclaimed-tasks>
			</div>
			<div *ngIf="activeTab === 'followups'">
				<app-my-follow-ups></app-my-follow-ups>
			</div>
			<div *ngIf="activeTab === 'mentions'">
				<app-my-mentions></app-my-mentions>
			</div>
		</div>
	</div>
</div>
